import API from "../../Confgs/Axios";
import {
  FETCH_BY_TRACKING,
  CREATE_TRX_RIDE,
  UPDATE_TRX_RIDE,
  FETCH_BY_TRACKING_CUSTOMER,
  STATE_NEAREST_DRIVERS,
  FETCH_BY_TRACKING_ANY,
  STATE_ORDER_DRIVER_PICKUP,
  STATE_COORDINATE_CUSTOMER,
  STATE_COORDINATE_DRIVER,
  FETCH_BY_TRX,
} from "../../Constants/actionTypes";
import { AppDispatch } from "../Reducers";


export const trxDetail = (idTrx:string) => async (dispatch:AppDispatch) => {
  try {
    const { data } = await API.get(`/api/v1/transaction/mp/${idTrx}`)
    dispatch({ type: FETCH_BY_TRX, payload: data?.data });
    return data;
  } catch (error) {
  }
};
export const showTracking = () => async (dispatch:AppDispatch) => {
  try {
    const { data } = await API.get(`/admin/tracking`)
    dispatch({ type: FETCH_BY_TRACKING, payload: data?.data });
    return data;
  } catch (error) {
  }
};

export const showTrackingCustomer = (id:any,) => async (dispatch:AppDispatch) => {
  try {
    const { data } = await API.get(`/admin/trackingCustomer?idTrx=${id}`)
    dispatch({ type: FETCH_BY_TRACKING_CUSTOMER, payload: data?.data });
  } catch (error) {
  }
};

export const showTrackingAny = (email:any, user_id:any) => async (dispatch:AppDispatch) => {
  try {
    const { data } = await API.get(`/admin/trackingAny?email=${email}&user_id=${user_id}`);
    dispatch({ type: FETCH_BY_TRACKING_ANY, payload: data?.data });
    return data;
  } catch (error) {
  }
};

  export const createTrxRide =
  (form: any) => async (dispatch: AppDispatch) => {
    try {
      const response = await API.post("/admin/order-ride", form);
      const resAPI = response?.data;
      dispatch({ type: CREATE_TRX_RIDE, payload: resAPI });
      return resAPI;
    } catch (err) {
      console.error("Error creating trx ride:", err);
      throw err;
    }
  };

  export const updateTrxRide =
  (form: any) => async (dispatch: AppDispatch) => {
    try {
      const response = await API.put("/admin/status-order-ride", form);
      const resAPI = response?.data;
      dispatch({ type: UPDATE_TRX_RIDE, payload: resAPI });
      return resAPI;
    } catch (err) {
      console.error("Error creating trx ride:", err);
      throw err; 
    }
  };

  export const negoTrxRide =
  (form: any) => async (dispatch: AppDispatch) => {
    try {
      const response = await API.put("/admin/negotiations-order-ride", form);
      const resAPI = response?.data;
      dispatch({ type: UPDATE_TRX_RIDE, payload: resAPI });
      return resAPI;
    } catch (err) {
      console.error("Error creating trx ride:", err);
      throw err; 
    }
  };

  export const approvalNegoTrxRide =
  (form: any) => async (dispatch: AppDispatch) => {
    try {
      const response = await API.put("/admin/approval-negotiations-order-ride", form);
      const resAPI = response?.data;
      dispatch({ type: UPDATE_TRX_RIDE, payload: resAPI });
      return resAPI;
    } catch (err) {
      console.error("Error creating trx ride:", err);
      throw err; 
    }
  };

export const saveStateNearestDrivers =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: STATE_NEAREST_DRIVERS,
        payload: data
      });
    } catch (error) {
    }
  };

export const saveStateOrderDriverPickup =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: STATE_ORDER_DRIVER_PICKUP,
        payload: data
      });
    } catch (error) {
    }
  };

  export const saveCoordinatCustomer =
  (data:any) => async (dispatch:AppDispatch) => {
    try {
      dispatch({
        type: STATE_COORDINATE_CUSTOMER,
        payload: data
      });
    } catch (error) {
    }
  };
  export const saveCoordinatDriver =
    (data:any) => async (dispatch:AppDispatch) => {
      try {
        dispatch({
          type: STATE_COORDINATE_DRIVER,
          payload: data
        });
      } catch (error) {
      }
    };
